import { render, staticRenderFns } from "./ThePersonalBannerCard.vue?vue&type=template&id=2f57aaa4&"
import script from "./ThePersonalBannerCard.vue?vue&type=script&lang=js&"
export * from "./ThePersonalBannerCard.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalBannerCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports